import { Link as RouterLink, useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import Table from './components/Table'
import PrintButton from '../../components/PrintButton'
import './styles.sass'

function FamilyContent({ familyId }) {
  const { i18n } = useTranslation(); // Add translation hook
  switch (familyId) {
    case "stocks": {
      return (
        <>
          <h1 className='h1 family-h1'>{i18n.t("Family.stocks_title")}</h1>
          <div className='family-h3-wrapper'>
            <h3 className='family-h3'>{i18n.t("Family.index_performance")}</h3>
          </div>
          <ul className='family-tab-list' style={{ listStyleType: 'square' }}>
            <RouterLink to="/family/stocks/0" className='family-tab-item'>{i18n.t("Family.all")}</RouterLink>
            <RouterLink to="/family/stocks/1" className='family-tab-item'>{i18n.t("Family.international_indices")}</RouterLink>
            <RouterLink to="/family/stocks/2" className='family-tab-item'>{i18n.t("Family.israeli_indices")}</RouterLink>
            <RouterLink to="/family/stocks/3" className='family-tab-item'>{i18n.t("Family.global_indices")}</RouterLink>
          </ul>
        </>
      )
    }
    case "bonds": {
      return (
        <>
          <h1 className='h1 family-h1'>{i18n.t("Family.bonds_title")}</h1>
          <div className='family-h3-wrapper'>
            <h3 className='family-h3'>{i18n.t("Family.index_performance")}</h3>
          </div>
          <ul className='family-tab-list'>
            <RouterLink to="/family/bonds/0" className='family-tab-item'>{i18n.t("Family.all")}</RouterLink>
            <RouterLink to="/family/bonds/1" className='family-tab-item'>{i18n.t("Family.government")}</RouterLink>
            <RouterLink to="/family/bonds/2" className='family-tab-item'>{i18n.t("Family.corporate")}</RouterLink>
          </ul>
        </>
      )
    }
    case "ai": {
      return (
        <>
          <h1 className='h1 family-h1'>{i18n.t("Family.ai_title")}</h1>
          <div className='family-h3-wrapper'>
            <h3 className='family-h3'>{i18n.t("Family.index_performance")}</h3>
          </div>
          <ul className='family-tab-list'>
            <RouterLink to="/family/ai/0" className='family-tab-item'>{i18n.t("Family.all")}</RouterLink>
            <RouterLink to="/family/ai/1" className='family-tab-item'>{i18n.t("Family.stocks")}</RouterLink>
            <RouterLink to="/family/ai/2" className='family-tab-item'>{i18n.t("Family.bonds")}</RouterLink>
          </ul>
        </>
      )
    }
    default:
      return (<></>)
  }
}

export default function Family() {
  const { familyId, subfamilyId } = useParams()
  const items = useSelector(state => state?.data?.allItems)
  const { i18n } = useTranslation()
  const isRtl = i18n.language === "he"; // Check if the current language is Hebrew (RTL)

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    })
  }

  return (
    <main className='main' style={{ direction: isRtl ? "rtl" : "ltr" }}>
      <FamilyContent familyId={familyId} />
      {items && <Table items={items} familyId={familyId} subfamilyId={subfamilyId} />}
      <button className='family-button' onClick={scrollToTop}>
        {i18n.t("Family.scroll_to_top")}
      </button>
      <PrintButton />
    </main>
  )
}
